// tool-uren-film.jsx: losse tool /tools/uren-film
// Film/AV ZZP: opdracht omschrijven → rol kiezen → timesheet invullen.
// Voorgevulde state: type=film, perspectief=uitvoerder (zzp).
// Geen AI; eindstation is StepTimesheet (toont urentotaal, geen 'verder' knop).
// Het zwaarteniveau dat StepTimesheet nodig heeft komt automatisch uit
// `niveaus[0]` van de gekozen rol (gezet door StepRol.verderMet).
import React from "react";
import { ToolShell } from "./tool-shell";
import { useToolState, useToolStep } from "./tool-storage";
import { StepRol } from "../ui/steps/step1-rol";
import { StepTimesheet } from "../ui/steps/step3-timesheet";

const TOOL_KEY = "uren-film";
const INITIAL_STATE = {
  type: "film",
  perspectief: "uitvoerder",
  omschrijving: "",
  rollen: [],
};

const STEPS = ["Opdrachtomschrijving", "Timesheet"];

// Tool-specifieke intro-copy (wijkt af van de volledige flow).
const ROL_TITEL = "Hoe bereken ik de uren?";
const ROL_INTRO = [
  "Een goede inschatting van de tijd die nodig is voor de afgesproken werkzaamheden is de basis voor een eerlijke vergoeding. Hier vind je timesheets die helpen om in te schatten hoeveel tijd noodzakelijk is voor de voorbereiding, uitvoering en afronding van werkzaamheden binnen een bepaalde rol voor het project. Neem deze mee naar je onderhandeling. Je opdrachtgever kan een andere inschatting hebben gemaakt. Ga daarover in gesprek.",
  "Er zijn timesheets voor verschillende departementen met werkzaamheden die vaak voorkomen.",
  "Kies hieronder eerst de rol uit de Rollengids.",
];
const TIMESHEET_INTRO =
  "Beschrijf eerst je eigen werkzaamheden en schat in hoeveel uur je daaraan besteedt. Hieronder vind je de meest gebruikelijke werkzaamheden in jouw departement, check of je niets gemist hebt en vul daar ook je uren in. Vul alleen de uren in die je aan de opdracht zelf besteedt: eigen administratie, acquisitie en scholing zitten al in de zzp-opslag.";

export const ToolUrenFilm = () => {
  const [state, setState] = useToolState(TOOL_KEY, INITIAL_STATE);
  const [step, setStep] = useToolStep(TOOL_KEY, STEPS.length - 1);

  const next = () => setStep(s => Math.min(STEPS.length - 1, s + 1));
  const back = () => setStep(s => Math.max(0, s - 1));

  return (
    <ToolShell steps={STEPS} currentStep={step} onJumpTo={setStep}>
      {step === 0 && (
        <StepRol
          state={state}
          setState={setState}
          next={next}
          disableAI
          titleOverride={ROL_TITEL}
          subOverride={ROL_INTRO}
        />
      )}
      {step === 1 && (
        <StepTimesheet
          state={state}
          setState={setState}
          back={back}
          hideNext
          niveauIsIndicatief
          subOverride={TIMESHEET_INTRO}
        />
      )}
    </ToolShell>
  );
};
